import { Reveal } from "./Reveal";
import { IMAGES } from "../data/content";

const PROJECTS = [
  {
    image: IMAGES.stadiumTribune,
    tag: "Projekt i madh",
    title: "Punime metalike për stadium",
    desc: "Prodhim dhe montim i rrethojave, parmakëve dhe çatisë së tribunës rreth të gjithë fushës së stadiumit – një projekt që kërkon precizion, volum të madh pune dhe instalim profesional.",
    points: ["Përmasa të mëdha", "Instalim profesional", "Qëndrueshmëri maksimale"],
  },
  {
    image: IMAGES.carwashExterior,
    tag: "Projekt i madh",
    title: "Konstruksione për autolarje",
    desc: "Konstruksione të mëdha metalike për objekte komerciale të larjes së automjeteve – struktura të forta, të ndërtuara për përdorim intensiv dhe jetëgjatësi.",
    points: ["Struktura industriale", "Objekte komerciale", "Ekzekutim profesional"],
  },
];

export const LargeProjects = () => (
  <section data-testid="large-projects-section" className="bg-graphite py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <p className="eyebrow mb-5">Kapacitet industrial</p>
        <h2 data-testid="large-projects-title" className="font-display text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
          Projekte të mëdha
        </h2>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-white/60 sm:text-lg">
          Nga punimet individuale deri te konstruksionet metalike me përmasa të mëdha – kapaciteti ynë mbulon çdo shkallë projekti.
        </p>
      </Reveal>

      <div className="mt-16 space-y-20">
        {PROJECTS.map((p, i) => (
          <Reveal key={p.title} delay={0.1}>
            <article
              data-testid={`large-project-${i}`}
              className={`grid items-center gap-10 lg:grid-cols-2 ${i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""}`}
            >
              <div className="group overflow-hidden">
                <img
                  src={p.image}
                  alt={p.title}
                  loading="lazy"
                  className="aspect-[16/11] w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105"
                />
              </div>
              <div className={i % 2 === 1 ? "lg:pr-10" : "lg:pl-10"}>
                <p className="eyebrow mb-4">{p.tag}</p>
                <h3 className="font-display text-2xl font-bold text-white sm:text-3xl lg:text-4xl">{p.title}</h3>
                <p className="mt-5 text-base leading-relaxed text-white/55">{p.desc}</p>
                <ul className="mt-7 space-y-3">
                  {p.points.map((pt) => (
                    <li key={pt} className="flex items-center gap-3 text-sm text-white/70">
                      <span className="h-px w-6 bg-bronze" />
                      {pt}
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
